export enum UserStatusEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DELETED = 'DELETED',
}
